import { createContext, useContext } from 'react';

export const AzureDevOpsOauthContext = createContext<{
    token: string;
}>({
    token: '',
});

export const useAzureDevOpsOauthContext = () => {
    return useContext(AzureDevOpsOauthContext);
};
